import './NavbarLinkButton.css';

import { Pages } from '@src/Pages';
import PropTypes from 'prop-types';
import React from 'react';
import { messageBox } from '@src/style/style';

/**
 * Creates a navbar link button.
 * @param {PendantPage} page The page to navigate to.
 * @param {string} title The button title.
 * @param {string} iconClass The button icon class name.
 * @param {boolean} isActive Whether the button should be active.
 * @param {() => void} onClick The action to perform when clicking the button, usually a navigation.
 * @param {boolean} isHidden Whether the button should be hidden.
 * @param {boolean} isRestricted Whether the access to the page should be restricted.
 * @param {boolean} isDisabled Whether the button is clickable or not
 * @returns {JSX.Element} The NavbarLinkButton React component.
 */
export function NavbarLinkButton ({ page, title, iconClass, onClick, isActive = false, isHidden = false, isRestricted = false, isDisabled = false }) {
  const activeClass = isActive ? 'navbar-active' : '';
  const hiddenStyle = isHidden ? { display: 'none' } : {};
  const titleAttribute = isRestricted ? `Please connect to the parent controller to make changes on the ${title} page.` : title;
  const disabledClass = isDisabled ? 'link-disabled' : '';

  // The VSE adds an error badge on the machine logic link button by selecting the id
  // Also the pill gets added multiple times now because they don't check if it's already there
  // TODO GD They should not be doing this, we should change how this is handled
  const id = page === Pages.MACHINE_LOGIC ? 'navbar_item_vse' : undefined;

  const onNavbarLinkClicked = () => {
    if (isRestricted) {
      messageBox(`Please connect to the parent controller to make changes on the ${title} page.`, 'info');
    }
    else {
      onClick();
    }
  };

  return (
    <a id={id} style={hiddenStyle} className={`navbar-link-item ${activeClass} ${disabledClass}`} onClick={onNavbarLinkClicked} title={titleAttribute}>
      <i className={`navbar-icon ${iconClass}`}></i>
      <h5 className="navbar-link-title">{title}</h5>
    </a>
  );
}

NavbarLinkButton.propTypes = {
  page: PropTypes.string,
  title: PropTypes.string,
  iconClass: PropTypes.string,
  onClick: PropTypes.func,
  isActive: PropTypes.bool,
  isHidden: PropTypes.bool,
  isRestricted: PropTypes.bool,
  isDisabled: PropTypes.bool,
};
